import Validator from "./Validator";

export default {
    /*
    *  Date utilities
    * */

    formatYYYYMMDD(datemoment) {
        if (datemoment === null) {
            return null
        }
        else {

            let date = datemoment._d;

            let year = date.getFullYear().toString();
            let month = (date.getMonth() + 1).toString();
            let day = date.getDate().toString();

            if (date.getMonth() + 1 < 10) {
                month = '0' + (date.getMonth() + 1).toString()
            }

            if (date.getDate() < 10) {
                day = '0' + date.getDate().toString()
            }

            return year + '-' + month + '-' + day;
        }
    },

    formatHHMM(time) {
        if (Boolean(time) || time == 0) {
            if (time < 10) {
                // możliwosci:
                // 5
                // 5.3
                // 5.35

                time = time.toString();
                if (time.length === 1) {
                    // 5
                    return '0' + time + ':00'
                }
                else if (time.length === 3) {
                    // 5.3
                    return '0' + time[0] + ':' + time[2] + '0'
                }
                else {
                    // 5.35
                    return '0' + (time).replace('.', ':')
                }

            }
            else {
                // mozliwosci:
                // 10
                // 10.3
                // 10.35

                time = time.toString();
                if (time.length === 2) {
                    // 10
                    return time + ':00'
                }
                else if (time.length === 4) {
                    // 10.3
                    return (time.replace('.', ':')) + '0'
                }
                else {
                    // 10.35
                    return (time).replace('.', ':')
                }

            }
        }

    },

    formatNormalTime(str) {
        // gdy dane przychodzą jako 6:33 albo 12:33
        if (str.length === 4) {
            return '0' + str
        } else return str
    },

    dodajGodzineDoCzasu(czas, godz) {
        let nowyczas = (parseInt(this.formatHHMM(godz).substr(0, 2)) * 60 * 60 * 1000) + (parseInt(this.formatHHMM(godz).substr(3, 5)) * 60 * 1000)
        return new Date(czas.getTime() + nowyczas)
    },

    formatDate(dateobject) {
        if (dateobject === null) {
            return null
        }
        else {
            return dateobject.toISOString().substr(0, 10)
        }
    },

    formatDateAndTime(dateobject) {
        if (dateobject === null) {
            return null
        }
        else {
            let tz = dateobject.getTimezoneOffset()
            return new Date(dateobject.getTime() + (tz * 60 * 1000 * -1)).toISOString().replace('T', ' ').substr(0, 16)
        }
    },

    parseTimeToFloat(time) {
        return parseFloat(time.replace(':', '.'))
    },

    // generowanie daty z roku (string: '2018'), miesiąca (object: {value:7, label:'lipiec'}), okresu (object: {value:'1p',label:'I pol'})
    wygenerujDate(rok, miesiac, okres) {
        if (Boolean(rok) && Boolean(miesiac) && Boolean(okres)) {
            if (Validator.validateInt(rok) && 2000 <= rok && rok <= 3000) {
                let msc = (miesiac.value.length === 1) ? '0' + miesiac.value : miesiac.value
                let data = rok + '-' + msc + '-';
                if (okres.value === '2p') {
                    data = data + '15'
                }
                else {
                    data = data + '01'
                }
                return data
            } else return null
        }
        else return null
    }


}


// WEBPACK FOOTER //
// ./src/utilities/DateAndTimeFormat.js